"use client"

import cn from "classnames"

import { HubspotForm } from "~/components/primitives/HubspotForm"
import { Modal } from "~/components/primitives/Modal/Modal"
import { type ModalId } from "~/contexts/ModalContext"

import s from "./ContactModal.module.scss"

type ContactModalProps = {
  id: ModalId
  ariaLabel: string
  title: string
  description: string
  formId: string
  className?: string
}

export const ContactModal = ({
  id,
  ariaLabel,
  title,
  description,
  formId,
  className,
}: ContactModalProps) => {
  // The embed script only binds `.hs-form-frame` placeholders that exist when
  // it initialises; anything added later gets an iframe with no src. So the
  // placeholder mounts eagerly and stays mounted, even while the dialog is
  // closed. Sharing a form id with the footer is fine — verified that two
  // placeholders with the same id both bind when both are present at init.
  return (
    <Modal id={id} aria-label={ariaLabel}>
      <div className={cn(s.content, className)}>
        <div>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <div>
          <HubspotForm formId={formId} />
        </div>
      </div>
    </Modal>
  )
}
